import styles from "./index.module.css";

function Container(props){
    return(
        //membungkus layout tiap component
        <div className={styles.container}>{props.children}</div>
    )
}

export default Container;